import styled from 'styled-components';
import { ReactElement } from 'react';

import { StyledFlex } from '@dreryk/react-components';

import { DocplannerIntegrationConfigurationLoader } from './DocplannerIntegrationConfigurationLoader';
import { DocplannerIntegrationForm } from './DocplannerIntegrationForm';
import { DocplannerIntegrationInformationSection } from './DocplannerIntegrationInformationSection';
import { DoctorsMappingsTable } from './doctorsMappings/DoctorsMappingsTable';
import { MedicalServicesMappingsTable } from './medicalServicesMappings/MedicalServicesMappingsTable';

const StyledDocplannerIntegrationPanelWrapper = styled(StyledFlex)`
   padding: 0 8px 24px 0;
`;
StyledDocplannerIntegrationPanelWrapper.displayName = 'StyledDocplannerIntegrationPanelWrapper';

export const DocplannerIntegrationPanel = (): ReactElement => {
   return (
      <DocplannerIntegrationConfigurationLoader>
         {({ docplannerIntegrationConfiguration, updateDocplannerConfiguration }) => (
            <StyledFlex direction={'column'}>
               {docplannerIntegrationConfiguration ? (
                  <StyledDocplannerIntegrationPanelWrapper direction={'column'} gap={'40px'}>
                     <DocplannerIntegrationInformationSection
                        clientId={docplannerIntegrationConfiguration.clientId}
                        docplannerInstitutionName={docplannerIntegrationConfiguration.externalName}
                        lastValidSynchronization={docplannerIntegrationConfiguration.lastValidSynchronization}
                        synchronizationDaysCount={docplannerIntegrationConfiguration.slotSynchronizationDuration}
                        onDocplannerConfigurationUpdated={updateDocplannerConfiguration}
                     />
                     <DoctorsMappingsTable />
                     <MedicalServicesMappingsTable />
                  </StyledDocplannerIntegrationPanelWrapper>
               ) : (
                  <DocplannerIntegrationForm onConfigurationCreateSuccess={updateDocplannerConfiguration} />
               )}
            </StyledFlex>
         )}
      </DocplannerIntegrationConfigurationLoader>
   );
};
